import createClient from 'openapi-fetch'
import { env } from '../env.ts'
import { fetch } from './helpers.ts'
import type { components, paths } from './user-manager.types.ts'

export const userManager = createClient<paths>({
	baseUrl: env.API_AURORAL,
	fetch,
})

type Schema = components['schemas']
export type UserEntity = Schema['UserEntity']
export type UserRoleEntity = Schema['UserRoleEntity']
export type CreateUserDto = Schema['CreateUserDto']
export type UpdateUserDto = Schema['UpdateUserDto']
export type UserListEntity = Schema['ContactListEntity']
export type CreateUserListDto = Schema['CreateContactListDto']
